import { toBool } from "./utils";
// Environment

const ENVIRONMENT = window.zino_env.react_app_environment;
export const API_ENV_URL = window.zino_env.react_app_base_url;

export const BASE_URL = ENVIRONMENT === "local" ? API_ENV_URL : window.location.origin;

export const APP_VERSION = window.zino_env.react_app_version;

export const ENCRYPTION_PUBLIC_KEY = window.zino_env.react_app_encryption_public_key;

export const USER_SERVICE_ENCRYPTION_PUBLIC_KEY = window.zino_env.react_app_encryption_public_key_user_service;

export const SAML_LOGIN_URL = "saml/login";

export const SHOW_SAML_LOGIN = toBool(window.zino_env.react_app_saml, false);
export const SHOW_COGNITO_LOGIN = toBool(window.zino_env.react_app_cognito, false);
export const SHOW_DEFAULT_LOGIN = toBool(window.zino_env.react_app_default_login, true);

const APP_DEPLOYMENT = window.zino_env.app_deployment || "";
export const IS_SANDBOX = APP_DEPLOYMENT === "SANDBOX" || APP_DEPLOYMENT === "";
export const IS_PRODUCTION = APP_DEPLOYMENT === "PRODUCTION" || APP_DEPLOYMENT === "";

// Storage Keys
export const STORAGE_KEYS = {
  ZINO_TOKEN: "zino_token",
  DARK_MODE: "darkMode",
  LIMIT: "limit"
};

export const SCREEN_WIDTHS = {
  desktop: "1600",
  tablet: "768",
  mobile: "512"
};

export const AI_PROVIDER_LIST = [
  { id: "open-ai", name: "OpenAI" },
  { id: "gemini", name: "Gemini" }
];

export const PUBLIC_ROUTES = ["/", "/resetpassword"];
